import { render } from "./AdminAdvertsView.vue?vue&type=template&id=0b10c3d4&scoped=true&ts=true"
import script from "./AdminAdvertsView.vue?vue&type=script&lang=ts"
export * from "./AdminAdvertsView.vue?vue&type=script&lang=ts"

import "./AdminAdvertsView.vue?vue&type=style&index=0&id=0b10c3d4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b10c3d4"]])

export default __exports__